import React from 'react';
import {useSelector} from 'react-redux';
import {orgRole} from 'redux/selectors/authSelector';
import {userRole, userDesignation} from 'constants/enums';
import {ORG_ADMIN, ORG_SUPER_ADMIN, PROJECT_MANAGER} from 'constants/keys';
import {projectPermissions} from 'redux/selectors/projectAnalyticsSelect';
import {UserPermissions} from 'redux/slices/projectAnalyticsSlice';

export function useAuthAccess() {
  const user_role = useSelector(orgRole)!;
  const permissions = useSelector(projectPermissions);

  let hasWriteAccess = false;
  let hasReadAccess = true;

  if (
    isSuperAdmin(user_role) ||
    isAdmin(user_role) ||
    hasProjectManagerAccess(permissions)
  ) {
    hasWriteAccess = true;
  }
  // check for project level access

  return {
    hasWriteAccess,
    hasReadAccess,
  };
}

function isSuperAdmin(user_role: number) {
  return user_role === userRole[ORG_SUPER_ADMIN];
}
function isAdmin(user_role: number) {
  return user_role === userRole[ORG_ADMIN];
}
function hasProjectManagerAccess(userPermissions: UserPermissions[]) {
  return Boolean(
    userPermissions?.find(item => item.id === userDesignation[PROJECT_MANAGER]),
  );
}
